<template>
    <div class="landing-page">
        <!-- header -->
        <div class="header">
            <div class="container d-flex align-items-center">
                <div class="menu">
                    <div class="logo">
                        <img class="img-logo-header" src="../../../assets/icons/football/ic_logoKickdun.png">
                    </div>
                    <div class="menu-list mobile">
                        <div class="language" @click="changeLanguage()">
                            <img src="../../../assets/icons/football/flag_UK.png" class="flat-icon" v-if="lang_btn=='en'"/>
                            <span class="lang-text" v-if="lang_btn=='en'">ENG</span>

                            <img src="../../../assets/icons/football/flag_VN.png" class="flat-icon" v-if="lang_btn=='vi'"/>
                            <span class="lang-text" v-if="lang_btn=='vi'">VI</span>
                        </div>
                        <i class="pi pi-bars" @click="showMenuListItems = true" v-if="!showMenuListItems"></i>
                        <i class="pi pi-times" @click="showMenuListItems = false" v-else></i>
                    </div>
                    <ul class="menu-list desktop">
                        <li class="menu-items" v-for="(items, index) in menuItems" :key="index">
                            <a @click="scrollMenuItems($event, items.link)">{{items.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="desktop download-menu">
                    <div class="language" @click="changeLanguage()">
                        <img src="../../../assets/icons/football/flag_UK.png" class="flat-icon" v-if="lang_btn=='en'"/>
                        <span class="lang-text" v-if="lang_btn=='en'">ENG</span>

                        <img src="../../../assets/icons/football/flag_VN.png" class="flat-icon" v-if="lang_btn=='vi'"/>
                        <span class="lang-text" v-if="lang_btn=='vi'">VI</span>
                    </div>
                    <div class="download-btn">
                        <span class="download-text">DOWNLOAD NOW</span>
                        <img src="../../../assets/icons/football/ic_apple.png" class="download-icon" />
                        <img src="../../../assets/icons/football/ic_android.png" class="download-icon" />
                    </div>
                </div>
            </div>
            <div class="menu-list-items" v-if="showMenuListItems">
                <ul class="menu-list mobile">
                    <li class="menu-items" v-for="(items, index) in menuItems" :key="index">
                        <a @click="scrollMenuItems($event, items.link)">{{items.name}}</a>
                    </li>
                </ul>
                <div class="mobile download-menu">
                    <div class="download-btn">
                        <span class="download-text">DOWNLOAD NOW</span>
                        <img src="../../../assets/icons/football/ic_apple.png" class="download-icon" />
                        <img src="../../../assets/icons/football/ic_android.png" class="download-icon" />
                    </div>
                </div>
            </div>
        </div>
        <div class="head-banners">
            <div class="mr-0 background-header"></div>
            <div class="container">
                <div class="text-banner">
                    <div class="header-text-banner">
                        <div>Download app,</div>
                        <div>Start play &amp; enjoy the moment!</div>
                    </div>
                    <div class="body-text-banner">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.
                    </div>
                    <div class="footer-text-banner">
                        <Button label="View more" class="p-button-success main-style-button" />
                    </div>
                </div>
                <div class="text-banner right">

                </div>
            </div>
        </div>
        <!-- body -->
        <div class="body">
            <div id="app-featureds">
                <div class="function-title">APP FEATUREDS</div>
                <div class="container">
                    <div class="function">
                        <div class="function-banner desktop">
                            <img class="function-img" src="../../../assets/icons/football/img_appscreen.png"/>
                        </div>
                        <div class="function-box">
                            <div class="function-items" :class="`${[(functions.length-1), (functions.length-2)].includes(index) ? 'last-items' : ''}`" v-for="(items, index) in functions" :key="index">
                                <div class="items-header">
                                    <img class="items-header-icon" :src="items.icon"/>
                                </div>
                                <div class="items-body">
                                    <div class="items-title">
                                        {{items.title}}
                                    </div>
                                    <div class="items-content">
                                        {{items.content}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="work">
                <div class="function-title">HOW THIS APP WORK</div>
                <div class="container">
                    <div class="function">
                        <div class="partner-box" v-for="(partner, index) in partners" :key="index">
                            <div class="partner-header">
                                <!-- <img class="partner-logo" :src="partner.logo"/> -->
                            </div>
                            <div class="partner-sub-header">
                                <!-- <img class="partner-logo" :src="partner.logo"/> -->
                                {{ partner.title }}
                                <div class="partner-box-line"></div>
                            </div>
                            <div class="partner-body">
                                {{ partner.content }}
                            </div>
                            <!-- <div class="partner-footer">
                                <div class="partner-box-line"></div>
                                <a href="#">Techtronic Industries</a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="container banners">
                <div class="text-banner">
                    DOWNLOAD THE APP TO EXPERIENCE CONVENIENT FEATURES
                </div>
                <div class="download-btn">
                    <span class="download-text">DOWNLOAD NOW</span>
                    <img src="../../../assets/icons/football/ic_apple.png" class="download-icon" />
                    <img src="../../../assets/icons/football/ic_android.png" class="download-icon" />
                </div>
            </div>

            
        </div>

        <!-- footer -->
        <div class="footer">
            <div class="container row m-auto pt-5">
                <div class="col-lg-6 col-12 pt-2 mb-4 px-0">
                    <div class="logo-footer">
                        <img class="img-logo-footer" src="../../../assets/icons/football/Logo_kickdun_white.png"/>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 px-0 pb-3">
                    <div class="about-us">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 px-0 pb-3">
                    <div class="company-name">KICKDUN COMPANY</div>
                    <div class="company-info mt-2 mb-2">
                        <div class="address">Address: &lt;danory company&gt;</div>
                        <div class="phone">Phone: <a>1234 567 891</a></div>
                        <div class="email">Email: kickdun.contact@support.com</div>
                        <div style="margin: 1em 0;"></div>
                        <div class="hotline">Hotline: <a>1234 567 891</a></div>
                        <div class="tax">TaxID: <a>123456789</a></div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 px-0 pb-3">
                    <div class="d-flex mb-5">
                        <div class="download-icon mr-3">
                            <img src="../../../assets/icons/football/app-chplay-1.png" />
                        </div>
                        <div class="download-icon">
                            <img src="../../../assets/icons/football/app-ios-1.png" />
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="social-icon mr-3">
                            <img src="../../../assets/icons/football/ic_facebook.png" />
                        </div>
                        <div class="social-icon">
                            <img src="../../../assets/icons/football/ic_instagram.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu-shadow" v-if="showMenuListItems" @click="showMenuListItems = false"></div>
    </div>
</template>

<script>
import jq from "jquery";
export default {
    name: "onePage",
    data() {
        return {
            lang_btn: 'en',
            showMenuListItems: false,
            menuItems: [
                {
                    link: "#app-featureds",
                    name: "APP FEATUREDS"
                },
                {
                    link: "#work",
                    name: "HOW THIS APP WORK"
                },
                // {
                //     link: "#work",
                //     name: "Đối tác"
                // }
            ],
            partners: [
                {   
                    title: "Lorem ipsum",
                    // logo: require("@/assets/icons/tti.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    title: "Lorem ipsum",
                    // logo: require("@/assets/icons/masan.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    title: "Lorem ipsum",
                    // logo: require("@/assets/icons/vinacafe.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    title: "Lorem ipsum",
                    // logo: require("@/assets/icons/achison.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                }
            ],
            packages: [],
            typeArr: {
                "DAY": "ngày",
                "MONTH": "tháng",
                "YEAR": "năm",
                "WEEK": "tuần"
            },
            functions: [
                {
                    icon: require("@/assets/icons/football/ic_findingoppoent.png"),
                    title: "Finding Opponents",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/football/ic_mercenary.png"),
                    title: "Mercenaries",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/football/ic_clubmanagement.png"),
                    title: "Club Management",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/football/ic_community.png"),
                    title: "Community",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/football/ic_clubranking.png"),
                    title: "Club Rankings",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                }
            ]
        }
    },
    watch: {
        "$route"() {
            setTimeout(() => {
                const hash = Object.assign({}, this.$route.hash);
                if (hash) {
                    history.pushState("", document.title, window.location.pathname + window.location.search);
                }
            }, 500);
        }
    },
    async created() {
        setTimeout(() => {
            const hash = Object.assign({}, this.$route.hash);
            if (hash) {
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }, 500);
        jq("#planding .function").on('scroll',function(){
            var WindowLeft = jq("#planding .function").scrollLeft();
            var stop = false;
            jq('.planding-box').each(function(i){
                var left = jq('.planding-box').eq(i).offset().left;
                var eleWidth = jq('.planding-box').eq(i).width();
                var scrollLeft = (left + (eleWidth + (10*i)))*i;
                if (scrollLeft < 0) {
                    scrollLeft = 0;
                }
                if(WindowLeft <= scrollLeft && !stop
                ){
                    jq('.planding-box').removeClass('active');
                    jq('.planding-page-item').removeClass('active');
                    jq('.planding-nav .planding-page-item').eq(i).addClass('active');
                    jq('.planding-box').eq(i).addClass('active');
                    stop = true;
                }
            });
        });
    },
    methods: {
        changeLanguage () {
            if (this.lang_btn == 'en') {
                this.lang_btn = 'vi';
            } else {
                this.lang_btn = 'en';
            }
        },
        async clickPlandingNav(e, id) {
            jq("#planding .function").animate({
                scrollLeft: '+='+jq(`#planding .function #page-${id}`).offset().left
            }, 0);
            e.stopPropagation();
        },
        async scrollMenuItems(e, link) {
            history.pushState("", document.title, window.location.pathname + window.location.search);
            this.showMenuListItems = false;
            jq("html").animate({
                scrollTop: (jq(link).offset().top-90)
            }, 300);
            e.preventDefault();
        },
    }
};
</script>

<style lang="scss" scoped>
html {
  scroll-behavior: smooth;
}
.landing-page {
    position: relative;
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
    .mobile {
        display: none !important;
    }
    .header {
        position: sticky;
        margin-bottom: 0.5em;
        top: 0;
        z-index: 9999;
        background-color: #ffffff;
        padding: 5px;
        box-shadow: 0 5px 10px 1px #d4d4d424;
        .menu {
            padding-top: 1em;
            display: flex;
            align-items: center;
            z-index: 1000;
            position: relative;
            .logo {
                .img-logo-header {
                    width: 100%;
                    height: 100%;
                }
            }
            .menu-list {
                margin: 0;
                display: flex;
                .menu-items {
                    padding: 0 1em;
                    text-transform: uppercase;
                    list-style: none;
                    a {
                        font-weight: bold;
                        color: #333333;
                        cursor: pointer;
                    }
                    a:hover {
                        color: #E73725;
                    }
                }
            }
        }
        .desktop.download-menu {
            z-index: 1000;
            flex: 1;
            display: flex;
            justify-content: flex-end;
            height: 100%;
            width: 100%;
            align-items: center;
            padding-top: 1em;
            position: relative;
            .language {
                cursor: pointer;
                padding: 5px 10px 5px 5px;
                border: 1px solid #F7DCD9;
                border-radius: 20px;
                display: flex;
                align-items: center;
                margin-right: 1em;
                .lang-text {
                    color: #6C0C03;
                    font-size: 12px;
                    margin-left: 3px;
                }
                .flat-icon {
                    border-radius: 5px;
                }
            }
            .download-btn {
                background-color: #E73725;
                padding: 10px 20px;
                display: flex;
                border-radius: 40px;
                align-items: center;
                cursor: pointer;
                .download-text {
                    color: #ffffff;
                    font-size: 16px;
                }
                .download-icon {
                    height: 30px;
                    width: 30px;
                    margin: 0 5px;
                    border: none;
                }
            }
        }
    }
    .head-banners {
        position: relative;
        min-height: calc(1080px* 0.8);
        margin-bottom: 2em;
        .text-banner {
            top: 10em;
            position: absolute;
            width: 40%;
            z-index: 1000;
            .header-text-banner {
                height: fit-content;
                font-size: calc(44px* 0.8);
                color: #861004;
                font-weight: bold;
                margin-bottom: .5em;
            }
            .body-text-banner {
                font-size: calc(14px* 0.8);
                color: #000000;
            }
            .footer-text-banner {
                margin-top: 2em;
                .main-style-button {
                    font-size: calc(16px*0.8);
                    width: calc(150px*0.8);
                    height: calc(48px*0.8);
                    border-radius: 8px;
                }
            }
        }
        .text-banner.right {
            top: 5em;
            right: 0;
            background-image: url('../../../assets/icons/football/img_clubdetailscreen.png');
            background-size: contain;
            height: calc(775px* 0.8);
            background-repeat: no-repeat;
            width: 35%;
        }
        .background-header {
            padding: 0;
            width: 100%;
            height: calc(1080px* 0.8);
            position: absolute;
            z-index: 5;
            top: 0;
            background-image: url('../../../assets/icons/football/img_bannerhome.png');
            background-size: cover;
        }
    }

    .body {
        margin-bottom: 0.5em;
        .function-title {
            margin: auto;
            text-align: center;
            color: #E73725;
            font-size: calc(21px* 0.8);
            font-weight: bold;
            &:before {
                background-color: #F7DCD9;
                height: calc(34px* 0.8);
                width: calc(34px* 0.8);
                content: "";
                border-radius: 50%;
                position: absolute;
                z-index: -2;
                margin: -2px -15px;
            }
            .small-text {
                color: #666666;
                font-size: calc(14px*0.8);
                margin-top: 0.2em;
            }
        }
        .function {
            width: 100%;
            margin-top: 0.5em;
            margin-bottom: 2em;
        }
        .banners {
            height: fit-content !important;
            width: 100%;
            // background-color: #861004;
            background-image: url('../../../assets/icons/football/img_banner_2.png');
            background-size: cover;
            background-position: center;
            padding: 30px;
            text-align: center;
            margin-bottom: 2em;
            .text-banner {
                position: relative !important;
                color: #fff;
                font-size: calc(24px*0.8);
                font-weight: bold;
                text-transform: uppercase;
            }
            .text-banner-small {
                color: #fff;
                font-size: calc(14px*0.8);
            }
            .text-banner-hotline {
                color: #F8D46E;
                font-size: calc(24px*0.8);
                text-transform: uppercase;
                font-weight: bold;
            }
            .download-btn {
                background-color: #FFFFFF;
                padding: 10px 20px;
                display: flex;
                width: 275px;
                margin: auto;
                border-radius: 40px;
                align-items: center;
                margin-top: 1em;
                margin-bottom: 1em;
                justify-content: space-between;
                cursor: pointer;
                .download-text {
                    color: #E73725;
                    font-size: 16px;
                    font-weight: bold;
                }
                .download-icon {
                    height: 30px;
                    width: 30px;
                    margin: 0 5px;
                    border: 1px solid #E73725;
                    border-radius: 50%;
                }
            }
        }
        #app-featureds {
            .function {
                display: flex;
                .function-banner {
                    height: auto;
                    flex-basis: 30%;
                    padding-right: 20px;
                    .function-img {
                        width: 100%;
                        height: 100%;
                        /* max-height: calc(546px*0.8); */
                    }
                }
                .function-box {
                    flex-basis: 70%;
                    display: flex;
                    flex-wrap: wrap;
                    .function-items.last-items {
                        padding-bottom: 0 !important;
                    }
                    .function-items {
                        width: 48%;
                        margin: 0 5px;
                        padding-bottom: 10px;
                        .items-header {
                            width: calc(64px* 0.8);
                            height: calc(64px* 0.8);
                            // background-color: #FDF5F4;
                            border-radius: 10px;
                            margin-bottom: 5px;
                            display: flex;
                            .items-header-icon {
                                width: 100%;
                                height: 100%;
                                margin: auto;
                                text-align: center;
                            }
                        }
                        .items-body {
                            .items-title {
                                color: #861004;
                                font-size: calc(18px* 0.8);
                                font-weight: bold;
                            }
                            .items-content {
                                font-size: calc(14px* 0.8);
                            }
                        }
                    }
                }
            }
        }
        #planding {
            margin-bottom: 2em;
            .function::-webkit-scrollbar {
                display: none;
            }
            .function-title {
                padding: 0 20px;
            }
            .function {
                margin-bottom: unset;
                display: flex;
                justify-content: space-between;
                scroll-behavior: smooth;
                scroll-snap-type: x mandatory;
                flex-wrap: wrap;
                .planding-box {
                    border: 1px solid #eee;
                    /*  width: calc(384px* 0.8); */
                    /* height: calc(384px* 0.8); */
                    flex-basis: 22%;
                    border-radius: 5px;
                    box-shadow: 0px 3px 3px 1px #00000029;
                    padding: 20px;
                    height: fit-content;
                    scroll-margin: 0 20px;
                    scroll-snap-align: center;
                    display: inline-block;
                    margin-bottom: 3em;
                    .planding-header {
                        text-align: center;
                        .price {
                            font-size: calc(30px* 0.8);
                            font-weight: bold;
                            .currency {
                                text-decoration: underline;
                            }
                        }
                        .text-small {
                            color: #6C747E;
                            font-size: calc(14px* 0.8);
                            font-weight: 400;
                        }
                        .package-name {
                            font-size: calc(20px* 0.8);
                            color: #666;
                            font-weight: bold;
                            margin: 1em 0;
                        }
                    }
                    .planding-body {
                        /* width: calc(384px* 0.6); */
                        width: 100%;
                        .description-box {
                            .description-items {
                                color: #6C747E;
                                font-size: calc(14px*0.8);
                                padding: 5px;
                                white-space: pre-wrap;
                            }
                            .description-items:before {
                                content: "\2713";
                                color: #861004;
                                font-weight: bold;
                                margin-right: 5px;
                                font-size: calc(16px* 0.8);
                            }
                        }
                    }
                    .planding-footer {
                        text-align: center;
                        margin-top: 1em;
                    }
                }
            }
            .planding-nav {
                margin: auto;
                text-align: center;
                a {
                    border: 1px solid #B4B4B4;
                    background-color: #fff;
                    border-radius: 50%;
                    padding: 5px;
                    font-size: 0px;
                    margin: 0 5px;
                }
                a.active {
                    background-color: #861004;
                }
            }
        }
        #work {
            .function::-webkit-scrollbar {
                display: none;
            }
            .function {
                padding: 4em 0 0;
                overflow-x: auto;
                overflow-y: hidden;
                white-space: nowrap;
                height: fit-content;
                justify-content: space-between;
                display: flex;
            }
            .partner-box {
                /* height: calc(338px*0.8); */
                width: calc(300px*0.8);
                background-color: #FDF5F4;
                border-radius: 20px;
                position: relative;
                margin-right: 1.5em;
                display: inline-block;
                padding: 0 10px 20px;
                .partner-header {
                    margin: auto;
                    text-align: center;
                    border-radius: 50%;
                    border: 4px solid #fff;
                    width: calc(126px* 0.8);
                    height: calc(126px* 0.8);
                    position: absolute;
                    top: -2.5em;
                    background-color: #FDF5F4;
                    left: 0;
                    right: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .partner-logo {
                        /* height: calc(80px* 0.8);
                        width: calc(80px* 0.8); */
                        scale: 0.8;
                    }
                }
                .partner-sub-header {
                    padding-top: 6em;
                    text-align: center;
                    color: #000000;
                    font-size: calc(16px*0.8);
                    font-weight: bold;
                    .partner-box-line{
                        width: 50%;
                        margin: auto;
                        height: 1px;
                        background-color: #eee;
                        margin-top: 1em;
                        margin-bottom: 1em;
                    }
                }
                .partner-body {
                    position: relative;
                    white-space: pre-wrap;
                    text-align: center;
                    font-size: calc(14px* 0.8);
                    padding-top: 0;
                }
                .partner-footer {
                    /* padding: 10px 0 0;
                    border-top: 1px solid #eee; */
                    text-align: center;
                    .partner-box-line{
                        width: 50%;
                        margin: auto;
                        height: 1px;
                        background-color: #eee;
                        margin-top: 5px;
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }

    .footer {
        position: relative;
        bottom: 0;
        height: 398px;
        width: 100%;
        background-color: #131313;
        color: #EAEAEA;
        padding-bottom: 2.5em;
        .company-name {
            // font-size: calc(24px*0.8);
            font-size: 14px;
            font-weight: bold;
        }
        .about-us{
            font-size: calc(14px*0.8);
            margin-bottom: 1em;
        }
        .img-logo-footer {
            width: calc(200px* 0.8);
            height: calc(87px* 0.8);
        }
        .img-icon-social {
            width: calc(40px*0.8);
            height: calc(40px*0.8);
        }
        .download-icon, .social-icon {
            cursor: pointer;
        }
        .company-info {
            font-size: calc(14px*0.8);
            .phone, .hotline {
                a {
                    color: #007BFF;
                    cursor: pointer;
                }
            }
        }
        .copy-right {
            font-size: calc(14px*0.8);
        }
    }
    @media (min-width: 768px) and (max-width: 920px) {
        .body {
            .function {
                .planding-box {
                    width: calc(768px* 0.8) !important;
                    .planding-body {
                        width: calc(768px* 0.6) !important;
                    }
                }
            }
        }
    }
    @media (min-width: 1000px) and (max-width: 1200px) {
        .body {
            .function {
                .planding-box {
                    width: calc(1000px* 0.8) !important;
                    .planding-body {
                        width: calc(1000px* 0.6) !important;
                    }
                }
            }
        }
    }
    @media (max-width: 1200px) {
        .menu-shadow {
            position: fixed;
            height: 100%;
            width: 100%;
            top: 0;
            z-index: 1111;
            background-color: #000000b5;
        }
        .mobile {
            display: block !important;
        }
        .desktop {
            display: none !important;
        }
        .header {
            position: sticky;
            /* overflow: hidden; */
            top: 0;
            z-index: 9999;
            background-color: #fff;
            border-bottom: 1px solid #eee;
            padding: 0;
            padding-bottom: 1em;
            box-shadow: 0 0 2px 2px #eeeeee87;
            .menu {
                justify-content: space-between;
                flex: 1;
                .menu-list.mobile {
                    display: flex !important;
                    align-items: center;
                    justify-content: space-between;
                    .language {
                        cursor: pointer;
                        padding: 5px 10px 5px 5px;
                        border: 1px solid #F7DCD9;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        margin-right: 1em;
                        .lang-text {
                            color: #6C0C03;
                            font-size: 12px;
                            margin-left: 3px;
                        }
                        .flat-icon {
                            border-radius: 5px;
                        }
                    }
                }
            }
            .menu-list-items {
                position: fixed;
                background-color: #fff;
                top: 4em;
                width: 100%;
                border-top: 1px solid #eee;
                .menu-list {
                    margin: 0;
                    padding: 10px;
                    .menu-items {
                        list-style: none;
                        padding: 5px;
                        a {
                            color: #333;
                            font-weight: bold;
                            cursor: pointer;
                        }
                    }
                }
                .download-menu {
                    border-top: 1px solid #eeeeee;
                    padding: 10px;
                    z-index: 1000;
                    display: flex !important;
                    justify-content: center;
                    height: 100%;
                    width: 100%;
                    align-items: center;
                    position: relative;
                    .download-btn {
                        background-color: #E73725;
                        padding: 10px 20px;
                        display: flex;
                        border-radius: 40px;
                        align-items: center;
                        cursor: pointer;
                        .download-text {
                            color: #ffffff;
                            font-size: 16px;
                        }
                        .download-icon {
                            height: 30px;
                            width: 30px;
                            margin: 0 5px;
                            border: none;
                        }
                    }
                }
            }
        }
        .head-banners {
            margin-bottom: 0.5em;
            min-height: fit-content;
            .background-header {
                position: relative;
                height: calc(258px* 0.8);
            }
            .text-banner {
                position: relative;
                width: 100%;
                top: 0;
            }
            .text-banner.right{
                position: absolute;
                height: calc(250px* 0.8);
                top: 0;
            }
        }
        .body {
            .function {
                margin-bottom: 1em;
            }
            /* .banners {
                .text-banner-hotline {
                    font-weight: bold;
                }
            } */
            #app-featureds {
                .function {
                    .function-box {
                        flex-basis: 100%;
                        .function-items {
                            width: 100%;
                            padding-bottom: 20px !important;
                        }
                        .function-items.last-items {
                            padding-bottom: 20px !important;
                        }
                    }
                }
            }
            #planding{
                .function-title {
                    padding: 0 35px;
                    .small-text {
                        font-weight: 400;
                    }
                }
                .function {
                    overflow-x: auto;
                    overflow-y: hidden;
                    width: 100%;
                    padding-bottom: 1em;
                    flex-wrap: nowrap;
                    justify-content: left;
                    .planding-box {
                        margin: 0 5px;
                        height: auto;
                        scale: .9;
                        .planding-body {
                            width: calc(384px* 0.7);
                        }
                    }
                    .planding-box.active {
                        scale: 1 !important;
                    }
                }
            }
            #work {
                .function {
                    display: inline-block;
                }
            }
        }
        .footer {
            height: fit-content;
        }
    }
}
</style>